import {WeaponGroupDTO, WeaponGroupItemDTO} from '../../dtos/weaponGroups'
import api from "../api";
import IWeapons from "../../interfaces/IWeapons";

export const getWeaponGroups = async () => {
    const response = await api.get<WeaponGroupDTO[]>('/api/weapon-groups')
    return response.data
}

export const getWeaponGroupById = async (id: string | undefined) => {
    const response = await api.get<WeaponGroupDTO>(`/api/weapon-groups/${id}`)
    return response.data
}

export const createWeaponGroup = async (data: {
    name: string
    size: 'C' | 'L'
    soul: 'L' | 'R'
    restricted: boolean
}) => {
    const response = await api.post<WeaponGroupDTO>('/api/weapon-groups', data)
    return response.data
}

export const updateWeaponGroup = async (id: number, data: {
    name: string
    size: 'C' | 'L'
    soul: 'L' | 'R'
    restricted: boolean
}) => {
    const response = await api.put<WeaponGroupDTO>(`/api/weapon-groups/${id}`, data)
    return response.data
}

export const deleteWeaponGroup = async (id: number) => {
    await api.delete(`/api/weapon-groups/${id}`)
}

export const createWeaponGroupItem = async (data: {
    weaponGroupId: number
    weaponCategoryId: number
    weaponOperationId: number
    caliberIds: number[]
}) => {
    const response = await api.post<WeaponGroupItemDTO>('/api/weapon-group-items', data)
    return response.data
}

export const getWeaponGroupItem = async (group_id: any) => {
    try {
        const response = await api.get<WeaponGroupItemDTO[]>('/api/weapon-group-items/' + group_id);
        return response.data;
    } catch (error: any) {
        if (error.response && error.response.status === 404) {
            return undefined;
        }
        throw error;
    }
}

export const updateWeaponGroupItem = async (
    id: number,
    data: {
        weaponGroupId: number
        weaponCategoryId: number
        weaponOperationId: number
        caliberIds: number[]
    }
) => {
    const response = await api.put<WeaponGroupItemDTO>(`/api/weapon-group-items/${id}`, data)
    return response.data
}

export const deleteWeaponGroupItem = async (id: number) => {
    await api.delete(`/api/weapon-group-items/${id}`)
}

export async function findWeaponGroup(weapon: IWeapons): Promise<WeaponGroupDTO | null> {
    const groups: WeaponGroupDTO[] = await getWeaponGroups()

    for (const group of groups) {
        if (group.size === weapon.weapon_size && group.soul === weapon.weapon_barrel) {
            for (const item of group.items) {
                const matchesCategory = item.weapon_category_id === weapon.weapon_category_id
                const matchesOperation = item.weapon_operation_id === weapon.weapon_operation_id
                const matchesCaliber = item.calibers.some((c) => c.id === weapon.caliber_id)

                if (matchesCategory && matchesOperation && matchesCaliber) {
                    return group
                }
            }
        }
    }

    return null
}
